import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	components: {
		app: {
			cardProps: {
				props: {
					title: 'My CPD',
				},
				queries: {},
			},
		},
		redirectButton: {
			show: true,
			redirectButtonProps: {
				redirect: {
					defaultUrl: '/',
				},
				text: 'VIEW DASHBOARD',
			},
		},
		summaryBlocks: {
			dataPoints: [
				{
					title: {
						queryOptionsType: 'none',
						value: 'Total',
					},
					value: {
						queryOptionsType: 'none',
						value: '{sub:total}min',
						subQueries: [
							{
								queryId: 'total',
								queryOptionsType: 'userConfiguration',
								options: {
									userConfiguration: {
										code: 'quiz',
										key: 'courses',
									},
								},
								transforms: [
									{
										transformOptionsType: 'aggregate',
										aggregateTransformOptions: {
											type: 'sum',
											key: 'cpd',
										},
									},
								],
							},
						],
					},
				},
				{
					title: {
						queryOptionsType: 'none',
						value: 'Structured',
					},
					value: {
						queryOptionsType: 'none',
						value: '{sub:structured}min',
						subQueries: [
							{
								queryId: 'structured',
								queryOptionsType: 'userConfiguration',
								options: {
									userConfiguration: {
										code: 'quiz',
										key: 'courses',
									},
								},
								transforms: [
									{
										transformOptionsType: 'filter',
										conditional: {
											conditions: [
												{
													field: 'cpdType',
													operator: '=',
													value: 'structured',
												},
											],
										},
									},
									{
										transformOptionsType: 'aggregate',
										aggregateTransformOptions: {
											type: 'sum',
											key: 'cpd',
										},
									},
								],
							},
						],
					},
				},
				{
					title: {
						queryOptionsType: 'none',
						value: 'Unstructured',
					},
					value: {
						queryOptionsType: 'none',
						value: '{sub:unstructured}min',
						subQueries: [
							{
								queryId: 'unstructured',
								queryOptionsType: 'userConfiguration',
								options: {
									userConfiguration: {
										code: 'quiz',
										key: 'courses',
									},
								},
								transforms: [
									{
										transformOptionsType: 'filter',
										conditional: {
											conditions: [
												{
													field: 'cpdType',
													operator: '=',
													value: 'unstructured',
												},
											],
										},
									},
									{
										transformOptionsType: 'aggregate',
										aggregateTransformOptions: {
											type: 'sum',
											key: 'cpd',
										},
									},
								],
							},
						],
					},
				},
			],
		},
	},
};
